import { useTranslation } from 'react-i18next';

import { Button, Modal } from 'antd';

import {
  setIsOpenApplicationTour,
  setIsOpenJobTour
} from 'features/tour/tourSlice';

import { useAppDispatch } from 'hooks/useTypedRedux';

import { GuideType } from 'constants/enums';

import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right-long.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import styles from './HowItWorksNoDataModal.module.scss';

interface HowItWorksNoDataModalProps {
  type: GuideType;
  isOpen: boolean;
  onClose: () => void;
}

const TRANSLATION_KEY_MAP = {
  [GuideType.Applications]: {
    multiple: 'tour.item.applications',
    single: 'tour.item.application'
  },
  [GuideType.Jobs]: {
    multiple: 'tour.item.jobs',
    single: 'tour.item.job'
  }
} as const;

const HowItWorksNoDataModal = ({
  type,
  isOpen,
  onClose
}: HowItWorksNoDataModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { multiple, single } = TRANSLATION_KEY_MAP[type];
  const titleItem = t(multiple);
  const subtitleItem = t(single);

  const handleClose = () => {
    dispatch(setIsOpenApplicationTour(false));
    dispatch(setIsOpenJobTour(false));
    onClose();
  };

  return (
    <Modal
      className={styles.modal}
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      closeIcon={
        <span className={styles.closeButton}>
          <CloseIcon />
        </span>
      }
      destroyOnHidden
    >
      <div className={styles.container}>
        <div className={styles.title}>
          {t('tour.noDataModal.title', { item: titleItem })}
        </div>
        <div className={styles.subtitle}>
          {t('tour.noDataModal.subtitle', { item: subtitleItem })}
        </div>

        <div className={styles.buttonsWrapper}>
          <Button type="link" className={styles.button} onClick={handleClose}>
            {t('tour.button.skip')}
          </Button>

          <Button
            type="primary"
            className={styles.button}
            onClick={handleClose}
            icon={<ArrowRightIcon />}
            iconPosition="end"
          >
            {t('tour.button.finish')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default HowItWorksNoDataModal;
